<template>
  <div id="app_calend">
    <div style="background-color: #e0ffff; text-align: center; font-size: 18px">
      В режиме тестирования
    </div>
    <h1><i class="fas fa-calendar-alt"></i> Календарь мероприятий</h1>

    <!-- Создание мероприятия -->
    <details v-if="selectedClass.classID === 'admin'">
      <summary><i class="fas fa-plus-circle"></i> Создание мероприятия</summary>
      <div class="details-content">
        <div class="form-section">
          <h3>Основная информация</h3>
          <div class="form-group">
            <label for="event-name">Наименование мероприятия:</label>
            <input
              id="event-name"
              type="text"
              class="form-control"
              v-model="newEvent.name"
              placeholder="Введите название мероприятия"
            />
          </div>

          <div class="form-group">
            <label for="event-description">Описание мероприятия:</label>
            <textarea
              id="event-description"
              class="form-control"
              v-model="newEvent.description"
              rows="3"
              placeholder="Добавьте описание мероприятия"
            ></textarea>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="date-from">Дата начала:</label>
                <input
                  id="date-from"
                  type="date"
                  class="form-control"
                  v-model="newEvent.date_from"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="date-until">Дата окончания:</label>
                <input
                  id="date-until"
                  type="date"
                  class="form-control"
                  v-model="newEvent.date_until"
                />
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Цвет мероприятия в календаре:</label>
            <div style="display: flex; align-items: center">
              <span
                class="color-preview"
                :style="{ backgroundColor: newEvent.color }"
              ></span>
              <input type="color" v-model="newEvent.color" />
            </div>
          </div>
        </div>

        <div class="form-section">
          <h3>Участники</h3>

          <div class="form-group">
            <label>Участвующие параллели:</label>
            <button
              class="btn"
              @click="pickAllParalls(newEvent.class_parallels)"
              style="background: #95a5a6; color: white"
            >
              <i class="fas fa-times"></i>Выбрать все
            </button>
            <div class="checkbox-group">
              <div class="checkbox-item" v-for="paral in 11" :key="paral">
                <input
                  :id="'paral' + paral"
                  type="checkbox"
                  :value="paral"
                  v-model="newEvent.class_parallels"
                />
                <label :for="'paral' + paral" style="margin-left: 5px">{{
                  paral
                }}</label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Участвующие классы:</label>
            <button
              class="btn"
              @click="pickAllParticipants(newEvent.class_participants)"
              style="background: #95a5a6; color: white"
            >
              <i class="fas fa-times"></i>Выбрать все
            </button>
            <div class="checkbox-group">
              <div class="checkbox-item" v-for="cls in classes" :key="cls._id">
                <input
                  :id="'class' + cls._id"
                  type="checkbox"
                  :value="cls._id"
                  v-model="newEvent.class_participants"
                />
                <label :for="'class' + cls._id" style="margin-left: 5px">{{
                  cls.className
                }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-section">
          <h3>Дополнительная информация</h3>
          <div class="form-group">
            <label for="navigator-url">Ссылка на навигатор (если есть):</label>
            <input
              id="navigator-url"
              type="text"
              class="form-control"
              v-model="newEvent.navigator_url"
              placeholder="https://..."
            />
          </div>
        </div>

        <button class="btn btn-primary" @click="createEvent()">
          <i class="fas fa-save"></i> Создать мероприятие
        </button>
      </div>
    </details>

    <!-- Фильтры -->
    <div class="filters">
      <div class="filter-group">
        <label for="parallel-filter">Фильтр по параллелям:</label>
        <select
          id="parallel-filter"
          class="filter-select"
          v-model="filters.parallel"
          @change="applyFilters"
        >
          <option value="">Все параллели</option>
          <option v-for="paral in 11" :key="paral" :value="paral">
            {{ paral }} класс
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label for="class-filter">Фильтр по классам:</label>
        <select
          id="class-filter"
          class="filter-select"
          v-model="filters.class"
          @change="applyFilters"
        >
          <option value="">Все классы</option>
          <option v-for="cls in classes" :key="cls._id" :value="cls._id">
            {{ cls.className }}
          </option>
        </select>
      </div>

      <div class="filter-group" style="align-self: flex-end">
        <button
          class="btn"
          @click="clearFilters"
          style="background: #95a5a6; color: white"
        >
          <i class="fas fa-times"></i> Сбросить фильтры
        </button>
      </div>
    </div>

    <!-- Календарь -->
    <div class="calendar-header">
      <div class="calendar-nav">
        <button @click="previousMonth">
          <i class="fas fa-chevron-left"></i> Предыдущий
        </button>
        <span class="month-title">{{ nameMonthView }} {{ currentYear }}</span>
        <button @click="nextMonth">
          Следующий <i class="fas fa-chevron-right"></i>
        </button>
      </div>
      <button class="btn btn-primary" @click="goToToday">Сегодня</button>
    </div>

    <table class="calendar-table">
      <thead>
        <tr>
          <th v-for="day in daysOfWeek" :key="day">{{ day }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(week, index) in calendarWeeks" :key="index">
          <td
            v-for="(day, dayIndex) in week"
            :key="dayIndex"
            :class="{ 'other-month': !day.isCurrentMonth, today: day.isToday }"
          >
            <div class="calendar-day">
              <div class="day-header">{{ day.date.getDate() }}</div>
              <div class="day-events">
                <div
                  v-for="event in filteredDayEvents(day.events)"
                  :key="event._id"
                  class="event-item"
                  :style="{
                    backgroundColor: event.color + '40',
                    borderLeftColor: event.color,
                  }"
                  @click="openEventModal(event)"
                >
                  <div class="event-title" :title="event.name">
                    {{
                      event.name.length > 25
                        ? event.name.substring(0, 25) + "..."
                        : event.name
                    }}
                  </div>
                </div>
                <div
                  v-if="
                    filteredDayEvents(day.events).length === 0 &&
                    day.events.length > 0
                  "
                  class="no-events"
                >
                  <small>События скрыты фильтром</small>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Модальное окно события -->
    <div
      class="event-modal"
      v-if="selectedEvent"
      @click.self="selectedEvent = null"
    >
      <div class="event-modal-content">
        <h2 style="margin-top: 0; color: var(--primary-color)">
          {{ selectedEvent.name }}
        </h2>

        <div class="form-group">
          <label><strong>Даты проведения:</strong></label>
          <p>
            {{ formatDate(selectedEvent.date_from) }} -
            {{ formatDate(selectedEvent.date_until) }}
          </p>
        </div>

        <div class="form-group" v-if="selectedEvent.description">
          <label><strong>Описание:</strong></label>
          <p style="white-space: pre-line">{{ selectedEvent.description }}</p>
        </div>

        <div
          class="form-group"
          v-if="
            selectedEvent.class_parallels &&
            selectedEvent.class_parallels.length
          "
        >
          <label><strong>Участвующие параллели:</strong></label>
          <div>
            <span
              v-for="paral in selectedEvent.class_parallels"
              :key="paral"
              class="parallel-badge"
              >{{ paral }}</span
            >
          </div>
        </div>

        <div
          class="form-group"
          v-if="
            selectedEvent.class_participants &&
            selectedEvent.class_participants.length
          "
        >
          <label><strong>Участвующие классы:</strong></label>
          <div>
            <span
              v-for="classId in selectedEvent.class_participants"
              :key="classId"
              class="class-badge"
            >
              {{ getClassName(classId) }}
            </span>
          </div>
        </div>

        <div class="form-group" v-if="selectedEvent.navigator_url">
          <label><strong>Ссылка на навигатор:</strong></label>
          <p>
            <a :href="selectedEvent.navigator_url" target="_blank">{{
              selectedEvent.navigator_url
            }}</a>
          </p>
        </div>

        <div
          style="
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 20px;
          "
        >
          <button
            v-if="selectedClass.classID === 'admin'"
            class="btn btn-primary"
            @click="openEditEventModal(selectedEvent)"
          >
            Редактировать
          </button>
          <button
            v-if="selectedClass.classID === 'admin'"
            class="btn btn-danger"
            @click="deleteEvent(selectedEvent)"
          >
            <i class="fas fa-trash"></i> Удалить
          </button>
          <button
            class="btn"
            @click="selectedEvent = null"
            style="background: #95a5a6; color: white"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>

    <!-- Модальное окно изменения события -->
    <div class="event-modal" v-if="selectedEventEdit">
      <div class="event-modal-content">
        <div class="form-group">
          <label for="event-name">Наименование мероприятия:</label>
          <input
            id="event-name"
            type="text"
            class="form-control"
            v-model="selectedEventEdit.name"
            placeholder="Введите название мероприятия"
          />
        </div>

        <div class="form-group">
          <label><strong>Даты проведения:</strong></label>
          <p>
            <input
              type="date"
              id="date-from"
              class="form-control"
              v-model="selectedEventEdit.date_from"
            />
            -
            <input
              type="date"
              id="date-from"
              class="form-control"
              v-model="selectedEventEdit.date_until"
            />
          </p>
        </div>

        <div class="form-group">
          <label><strong>Описание:</strong></label>
          <textarea
            id="event-description"
            class="form-control"
            v-model="selectedEventEdit.description"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label>Цвет мероприятия в календаре:</label>
          <div style="display: flex; align-items: center">
            <span
              class="color-preview"
              :style="{ backgroundColor: selectedEventEdit.color }"
            ></span>
            <input type="color" v-model="selectedEventEdit.color" />
          </div>
        </div>

        <div class="form-section">
          <h3>Участники</h3>
          <div class="form-group">
            <label>Участвующие параллели:</label>
            <div class="checkbox-group">
              <button
                class="btn"
                @click="pickAllParalls(selectedEventEdit.class_parallels)"
                style="background: #95a5a6; color: white"
              >
                <i class="fas fa-times"></i>Выбрать все
              </button>
              <div class="checkbox-item" v-for="paral in 11" :key="paral">
                <input
                  :id="'paral' + paral"
                  type="checkbox"
                  :value="paral"
                  v-model="selectedEventEdit.class_parallels"
                />
                <label :for="'paral' + paral" style="margin-left: 5px">{{
                  paral
                }}</label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Участвующие классы:</label>
            <button
              class="btn"
              @click="pickAllParticipants(selectedEventEdit.class_participants)"
              style="background: #95a5a6; color: white"
            >
              <i class="fas fa-times"></i>Выбрать все
            </button>
            <div class="checkbox-group">
              <div class="checkbox-item" v-for="cls in classes" :key="cls._id">
                <input
                  :id="'class' + cls._id"
                  type="checkbox"
                  :value="cls._id"
                  v-model="selectedEventEdit.class_participants"
                />
                <label :for="'class' + cls._id" style="margin-left: 5px">{{
                  cls.className
                }}</label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label><strong>Ссылка на навигатор:</strong></label>
            <p>
              <input
                type="text"
                id="date-from"
                class="form-control"
                v-model="selectedEventEdit.navigator_url"
              />
            </p>
          </div>
        </div>
        <div
          style="
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 20px;
          "
        >
          <button
            v-if="selectedClass.classID === 'admin'"
            class="btn btn-success"
            @click="editEvent(selectedEventEdit)"
          >
            <i class="fas fa-trash"></i> Обновить
          </button>
          <button
            class="btn"
            @click="selectedEventEdit = null"
            style="background: #95a5a6; color: white"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>

    <!-- Список всех мероприятий -->
    <details>
      <summary><i class="fas fa-list"></i> Все мероприятия месяца</summary>
      <div class="details-content">
        <table class="events-table">
          <thead>
            <tr>
              <th>№</th>
              <th>Название</th>
              <th>Даты проведения</th>
              <th>Участвующие параллели</th>
              <th>Участвующие классы</th>
              <th>Ссылка на навигатор</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(event, index) in filterEventsBySelectedMonth()"
              :key="event._id"
            >
              <td>{{ index + 1 }}</td>
              <td @click="openEventModal(event)" style="cursor: pointer">
                {{ event.name }}
              </td>
              <td>
                {{ formatDate(event.date_from) }} -
                {{ formatDate(event.date_until) }}
              </td>
              <td>
                <span
                  v-for="paral in event.class_parallels"
                  :key="paral"
                  class="parallel-badge"
                  >{{ paral }}</span
                >
              </td>
              <td>
                <span
                  v-for="classId in event.class_participants"
                  :key="classId"
                  class="class-badge"
                >
                  {{ getClassName(classId) }}
                </span>
              </td>
              <td>
                <a
                  v-if="event.navigator_url"
                  :href="event.navigator_url"
                  target="_blank"
                  >{{ event.navigator_url }}</a
                >
                <span v-else>-</span>
              </td>
              <td>
                <button
                  class="btn btn-primary"
                  @click="openEditEventModal(event)"
                  style="
                    padding: 5px 10px;
                    font-size: 0.8rem;
                    margin-right: 5px;
                  "
                  v-if="selectedClass.classID === 'admin'"
                >
                  Редактировать
                </button>
                <button
                  class="btn btn-danger"
                  @click="deleteEvent(event)"
                  style="padding: 5px 10px; font-size: 0.8rem"
                  v-if="selectedClass.classID === 'admin'"
                >
                  Удалить
                </button>
              </td>
            </tr>
            <tr v-if="filteredEvents.length === 0">
              <td colspan="7" class="no-events">
                Нет мероприятий, соответствующих фильтрам
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </details>
  </div>
</template>

<script>
import TutorialDataService from "../services/TutorialDataService";
export default {
  props: {
    selectedClass: Object,
  },
  data() {
    return {
      currentDate: new Date(),
      newEvent: {
        name: "",
        description: "",
        date_from: new Date().toISOString().slice(0, 10),
        date_until: new Date().toISOString().slice(0, 10),
        color: "#3498db",
        navigator_url: "",
        class_parallels: [],
        class_participants: [],
      },
      selectedEvent: null,
      selectedEventEdit: null,
      daysOfWeek: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"],
      filters: {
        parallel: "",
        class: "",
      },
      classes: [
        { _id: "1a", className: "1А" },
        { _id: "1b", className: "1Б" },
        { _id: "2a", className: "2А" },
        { _id: "2b", className: "2Б" },
        { _id: "3a", className: "3А" },
        { _id: "3b", className: "3Б" },
        { _id: "4a", className: "4А" },
        { _id: "4b", className: "4Б" },
        { _id: "5a", className: "5А" },
        { _id: "5b", className: "5Б" },
        { _id: "6a", className: "6А" },
        { _id: "6b", className: "6Б" },
        { _id: "7a", className: "7А" },
        { _id: "7b", className: "7Б" },
        { _id: "8a", className: "8А" },
        { _id: "8b", className: "8Б" },
        { _id: "9a", className: "9А" },
        { _id: "9b", className: "9Б" },
        { _id: "10a", className: "10А" },
        { _id: "10b", className: "10Б" },
        { _id: "11a", className: "11А" },
        { _id: "11b", className: "11Б" },
      ],
      events: [
        {
          _id: "1",
          name: "Школьная ярмарка с очень длинным названием которое не помещается в одну строку",
          description:
            "Ежегодная школьная ярмарка с участием всех классов. Приносите домашнюю выпечку и поделки для продажи.",
          date_from: new Date(2024, 4, 1),
          date_until: new Date(2024, 4, 3),
          color: "#90FB98",
          class_parallels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
          class_participants: ["1a", "1b", "2a", "2b", "3a", "3b"],
        },
        {
          _id: "2",
          name: "Научная конференция",
          description:
            "Школьная научная конференция для учащихся 8-11 классов. Представление исследовательских проектов.",
          date_from: new Date(2024, 4, 10),
          date_until: new Date(2024, 4, 12),
          color: "#FFB6C1",
          class_parallels: [8, 9, 10, 11],
          class_participants: [
            "8a",
            "8b",
            "9a",
            "9b",
            "10a",
            "10b",
            "11a",
            "11b",
          ],
          navigator_url: "https://example.com/navigator",
        },
        {
          _id: "3",
          name: "Спортивный праздник",
          description:
            "Соревнования между классами по различным видам спорта. Призы для победителей.",
          date_from: new Date(2024, 4, 15),
          date_until: new Date(2024, 4, 15),
          color: "#87CEEB",
          class_parallels: [1, 2, 3, 4, 5],
          class_participants: [
            "1a",
            "1b",
            "2a",
            "2b",
            "3a",
            "3b",
            "4a",
            "4b",
            "5a",
            "5b",
          ],
        },
      ],
    };
  },
  computed: {
    nameMonthView() {
      const months = [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ];
      return months[this.currentDate.getMonth()];
    },
    currentYear() {
      return this.currentDate.getFullYear();
    },
    calendarWeeks() {
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();

      // Первый день месяца
      const firstDay = new Date(year, month, 1);
      // Последний день месяца
      const lastDay = new Date(year, month + 1, 0);

      // Начало календаря (понедельник первой недели)
      const startDate = new Date(firstDay);
      startDate.setDate(
        startDate.getDate() -
          (firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1),
      );

      // Конец календаря (воскресенье последней недели)
      const endDate = new Date(lastDay);
      endDate.setDate(
        endDate.getDate() + (lastDay.getDay() === 0 ? 0 : 7 - lastDay.getDay()),
      );

      const weeks = [];
      let currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        const week = [];

        for (let i = 0; i < 7; i++) {
          const date = new Date(currentDate);
          const isCurrentMonth = date.getMonth() === month;
          const isToday = this.isToday(date);

          // Находим события для этого дня
          const dayEvents = this.events.filter((event) => {
            const eventStart = new Date(event.date_from);
            const eventEnd = new Date(event.date_until);
            eventStart.setHours(0, 0, 0, 0);
            eventEnd.setHours(0, 0, 0, 0);
            date.setHours(0, 0, 0, 0);

            return date >= eventStart && date <= eventEnd;
          });

          week.push({
            date: date,
            isCurrentMonth: isCurrentMonth,
            isToday: isToday,
            events: dayEvents,
          });

          currentDate.setDate(currentDate.getDate() + 1);
        }

        weeks.push(week);
      }

      return weeks;
    },
    filteredEvents() {
      if (!this.filters.parallel && !this.filters.class) {
        return this.events;
      }

      return this.events.filter((event) => {
        const parallelMatch =
          !this.filters.parallel ||
          event.class_parallels.includes(parseInt(this.filters.parallel));

        const classMatch =
          !this.filters.class ||
          event.class_participants.includes(this.filters.class);

        return parallelMatch && classMatch;
      });
    },
  },
  methods: {
    pickAllParticipants(participantsArray) {
      if (participantsArray.length === this.classes.length) {
        // Очищаем массив
        participantsArray.splice(0, participantsArray.length);
      } else {
        // Выбираем все классы
        participantsArray.splice(0, participantsArray.length);
        for (let i = 0; i < this.classes.length; i++) {
          participantsArray.push(this.classes[i]._id);
        }
      }
    },
    pickAllParalls(parallelsArray) {
      if (parallelsArray.length === 11) {
        // Очищаем массив
        parallelsArray.splice(0, parallelsArray.length);
      } else {
        // Заполняем числами от 1 до 11
        parallelsArray.splice(
          0,
          parallelsArray.length,
          ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
        );
      }
    },
    async getAllEvent() {
      await TutorialDataService.getAllEvent().then((res) => {
        this.events = res.data;
        console.log(this.events);
        this.$forceUpdate();
      });
    },
    async createEvent() {
      if (!this.newEvent.name) {
        alert("Пожалуйста, введите название мероприятия");
        return;
      }

      const event = {
        name: this.newEvent.name,
        description: this.newEvent.description,
        date_from: new Date(this.newEvent.date_from),
        date_until: new Date(this.newEvent.date_until),
        color: this.newEvent.color,
        navigator_url: this.newEvent.navigator_url,
        class_parallels: [...this.newEvent.class_parallels],
        class_participants: [...this.newEvent.class_participants],
      };

      //  this.events.push(event);
      await TutorialDataService.createEvent(event)
        .then((response) => {
          console.log("УСПЕШНО ОТПРАВЛЕНО", response);
          this.getAllEvent();
        })
        .catch((e) => {
          console.log("1111111111", e);
        });

      // Сброс формы
      this.newEvent = {
        name: "",
        description: "",
        date_from: new Date().toISOString().slice(0, 10),
        date_until: new Date().toISOString().slice(0, 10),
        color: "#3498db",
        navigator_url: "",
        class_parallels: [],
        class_participants: [],
      };
    },
    async deleteEvent(event) {
      if (
        confirm(`Вы уверены, что хотите удалить мероприятие "${event.name}"?`)
      ) {
        await TutorialDataService.deleteEvent(event._id)
          .then(() => {
            this.getAllEvent();
            this.selectedEvent = null;
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },

    openEditEventModal(event) {
      this.selectedEventEdit = event;
      this.selectedEventEdit.date_from = new Date(event.date_from)
        .toISOString()
        .slice(0, 10);
      this.selectedEventEdit.date_until = new Date(event.date_until)
        .toISOString()
        .slice(0, 10);
    },

    async editEvent(event) {
      if (!event.name) {
        alert("Пожалуйста, введите название мероприятия");
        return;
      }

      const update_event = {
        name: this.selectedEventEdit.name,
        description: this.selectedEventEdit.description,
        date_from: new Date(this.selectedEventEdit.date_from),
        date_until: new Date(this.selectedEventEdit.date_until),
        color: this.selectedEventEdit.color,
        navigator_url: this.selectedEventEdit.navigator_url,
        class_parallels: [...this.selectedEventEdit.class_parallels],
        class_participants: [...this.selectedEventEdit.class_participants],
      };

      await TutorialDataService.editEvent(event._id, update_event)
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            console.log("УСПЕШНО ОТПРАВЛЕНО", response);
            alert("Успешно!");
            this.getAllEvent();
            this.selectedEventEdit = null;
          } else {
            console.log("Ошибка со статусом:", response.status);
            // Обработка ошибок
            alert("Ошибка!");
          }
        })
        .catch((e) => {
          console.log("error", e);
        });

      // Сброс формы
    },
    openEventModal(event) {
      this.selectedEvent = event;
    },
    previousMonth() {
      this.currentDate = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth() - 1,
        1,
      );
    },
    filterEventsBySelectedMonth() {
      let events = this.events;
      let currentDate = this.currentDate;
      // Получаем год и месяц из текущей выбранной даты
      const selectedYear = currentDate.getFullYear();
      const selectedMonth = currentDate.getMonth(); // 0-январь, 1-февраль, ..., 11-декабрь

      // Фильтруем мероприятия
      return events.filter((event) => {
        // Преобразуем даты мероприятия в объекты Date
        const eventDateFrom = new Date(event.date_from);
        const eventDateUntil = new Date(event.date_until);

        // Проверяем, что мероприятие проходит в выбранном месяце и году
        // (проверяем обе даты - начала и окончания)
        const isEventInSelectedMonth =
          (eventDateFrom.getFullYear() === selectedYear &&
            eventDateFrom.getMonth() === selectedMonth) ||
          (eventDateUntil.getFullYear() === selectedYear &&
            eventDateUntil.getMonth() === selectedMonth);

        return isEventInSelectedMonth;
      });
    },
    nextMonth() {
      this.currentDate = new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth() + 1,
        1,
      );
    },
    goToToday() {
      this.currentDate = new Date();
    },
    isToday(date) {
      const today = new Date();
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      );
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("ru-RU");
    },
    getClassName(classId) {
      const cls = this.classes.find((c) => c._id === classId);
      return cls ? cls.className : classId;
    },
    applyFilters() {
      // Фильтры применяются автоматически через computed свойство
    },
    clearFilters() {
      this.filters.parallel = "";
      this.filters.class = "";
    },
    filteredDayEvents(events) {
      if (!this.filters.parallel && !this.filters.class) {
        return events;
      }

      return events.filter((event) => {
        const parallelMatch =
          !this.filters.parallel ||
          event.class_parallels.includes(parseInt(this.filters.parallel));

        const classMatch =
          !this.filters.class ||
          event.class_participants.includes(this.filters.class);

        return parallelMatch && classMatch;
      });
    },
  },
  async mounted() {
    await TutorialDataService.getAllCLass()
      .then((response) => {
        this.classes = response.data;
      })
      .catch((e) => {
        console.log(e);
      });

    await this.getAllEvent();
  },
};
</script>

<style scoped>
/* Удаляем :root и body из scoped стилей - они не работают здесь */
#app_calend {
  --primary-color: #3498db;
  --secondary-color: #2ecc71;
  --danger-color: #e74c3c;
  --light-bg: #f8f9fa;
  --border-color: #dee2e6;

  max-width: 1400px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 25px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
}

#app_calend h1 {
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 25px;
  font-weight: 600;
}

#app_calend .calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background: var(--light-bg);
  border-radius: 8px;
}

#app_calend .calendar-nav {
  display: flex;
  align-items: center;
  gap: 15px;
}

#app_calend .calendar-nav button {
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 15px;
  cursor: pointer;
  transition: background 0.3s;
  font-weight: 500;
}

#app_calend .calendar-nav button:hover {
  background: #2980b9;
}

#app_calend .month-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
}

#app_calend .calendar-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
}

#app_calend .calendar-table th {
  background: var(--primary-color);
  color: white;
  padding: 12px 5px;
  text-align: center;
  font-weight: 500;
}

#app_calend .calendar-table td {
  border: 1px solid var(--border-color);
  padding: 0;
  vertical-align: top;
  height: 120px;
  max-width: 30px;
}

#app_calend .calendar-day {
  height: 100%;
  display: flex;
  flex-direction: column;
}

#app_calend .day-header {
  padding: 5px;
  text-align: center;
  border-bottom: 1px solid var(--border-color);
  background: var(--light-bg);
  font-weight: 500;
}

#app_calend .today .day-header {
  background: var(--primary-color);
  color: white;

  display: flex;
  align-items: center;
  justify-content: center;
}

#app_calend .day-events {
  flex-grow: 1;
  padding: 5px;
  overflow-y: auto;
  max-height: 90px;
}

#app_calend .event-item {
  margin-bottom: 5px;
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border-left: 3px solid;
  max-width: 100%;
  overflow: hidden;
}

#app_calend .event-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

#app_calend .event-title {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

#app_calend .other-month {
  background-color: #b9dcff;
  color: #333333;
}

#app_calend .event-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

#app_calend .event-modal-content {
  background: white;
  padding: 25px;
  border-radius: 10px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
}

#app_calend .form-section {
  background: var(--light-bg);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

#app_calend .form-section h3 {
  margin-top: 0;
  color: var(--primary-color);
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 10px;
}

#app_calend .form-group {
  margin-bottom: 15px;
}

#app_calend .form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

#app_calend .form-control {
  width: 95%;
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 1rem;
}

#app_calend .checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

#app_calend .checkbox-item {
  display: flex;
  align-items: center;
}

#app_calend .btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s;
}

#app_calend .btn-primary {
  background: var(--primary-color);
  color: white;
}

#app_calend .btn-primary:hover {
  background: #2980b9;
}

#app_calend .btn-danger {
  background: var(--danger-color);
  color: white;
}

#app_calend .btn-danger:hover {
  background: #c0392b;
}

#app_calend .events-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

#app_calend .events-table th,
#app_calend .events-table td {
  border: 1px solid var(--border-color);
  padding: 10px;
  text-align: left;
}

#app_calend .events-table th {
  background: var(--primary-color);
  color: white;
}

#app_calend .events-table tr:nth-child(even) {
  background: var(--light-bg);
}

#app_calend .parallel-badge {
  display: inline-block;
  background: var(--secondary-color);
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  margin-right: 5px;
  margin-bottom: 5px;
}

#app_calend .class-badge {
  display: inline-block;
  background: #3498db;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  margin-right: 5px;
  margin-bottom: 5px;
}

#app_calend details {
  margin-bottom: 25px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  overflow: hidden;
}

#app_calend details > summary {
  padding: 15px 20px;
  background: var(--light-bg);
  cursor: pointer;
  font-weight: 500;
  font-size: 1.1rem;
}

#app_calend details[open] > summary {
  border-bottom: 1px solid var(--border-color);
}

#app_calend .details-content {
  padding: 20px;
}

#app_calend .color-preview {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  margin-right: 10px;
  vertical-align: middle;
}

#app_calend .filters {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  padding: 15px;
  background: var(--light-bg);
  border-radius: 8px;
}

#app_calend .filter-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

#app_calend .filter-group label {
  font-weight: 500;
  font-size: 0.9rem;
}

#app_calend .filter-select {
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  min-width: 150px;
}

#app_calend .no-events {
  text-align: center;
  padding: 20px;
  color: #7f8c8d;
  font-style: italic;
}

@media (max-width: 768px) {
  #app_calend .calendar-table td {
    height: 80px;
  }

  #app_calend .event-item {
    font-size: 0.7rem;
    padding: 3px 5px;
  }

  #app_calend .calendar-nav {
    flex-direction: column;
    gap: 10px;
  }

  #app_calend .filters {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
